// MarketWatch.js
import React, { useRef, useEffect } from 'react';
import SuperStarInstrumentsGrid from "../superstar/SuperStarInstrumentsGrid";
import GUIInstrumentGridID from './grids/GUIInstrumentGridID';
import DefaultGridComponent from './grids/DefaultGridComponent';

import './css/MarketWatch.css';

const MarketWatch = ({ tabList, isDataLoaded: isDataContextLoaded,setSelectedToken,setSelectedChartSymbol  }) => {
    const scrollContainerRef = useRef(null);

    useEffect(() => {
        if (!isDataContextLoaded || tabList.length === 0) {
            //console.log("Data is not yet loaded or tabList is empty");
            return;
        }
    }, [ ]);  // Re-run when isDataContextLoaded or tabList changes
    useEffect(() => {
        const handleAfterRender = () => {
            const scrollContainer = scrollContainerRef.current;
            if (!scrollContainer) {
                console.log("scrollContainer is still null after render");
                return;
            }

            const contentElement = scrollContainer.querySelector('.instrument-grid-holder');
            if (!contentElement) {
                console.log("No .content elements found after render");
                return;
            }

            //console.log("scrollContainer and .content elements found, proceeding");

            let currentPosition = 0;
            const divWidth = contentElement.offsetWidth + 20; // Adjust according to actual margin/padding
            const numberOfDivsToScroll = 4; // Scroll 4 divs at a time

            // Function to handle the arrow key press
            const handleKeyPress = (e) => {
                if (e.key === 'ArrowRight' || e.key === 'ArrowLeft') {
                    e.preventDefault();
                    const totalScrollWidth = scrollContainer.scrollWidth;

                    if (e.key === 'ArrowRight') {
                        if (currentPosition + divWidth * numberOfDivsToScroll < totalScrollWidth) {
                            currentPosition += divWidth * numberOfDivsToScroll;
                            scrollContainer.scrollLeft = currentPosition;
                        }
                    } else if (e.key === 'ArrowLeft') {
                        if (currentPosition - divWidth * numberOfDivsToScroll >= 0) {
                            currentPosition -= divWidth * numberOfDivsToScroll;
                            scrollContainer.scrollLeft = currentPosition;
                        }
                    }
                }
            };

            document.addEventListener('keydown', handleKeyPress);

            return () => {
                document.removeEventListener('keydown', handleKeyPress);
            };
        };

        // Defer execution to allow DOM to render
        /*setTimeout(handleAfterRender, 0); // 0ms delay gives React time to complete DOM rendering*/
        //console.log("Setting up setTimeout...");
        setTimeout(() => {
            //console.log("Inside handleAfterRender function...");
            handleAfterRender();
        }, 0);

    }, [isDataContextLoaded, tabList]);  // Re-run when isDataContextLoaded or tabList changes

    const renderGridComponent = (tabID) => {
        switch (tabID) {
            case 1:
                return <GUIInstrumentGridID tabID={tabID} setSelectedToken={setSelectedToken} setSelectedChartSymbol={setSelectedChartSymbol}/>;
            case 2:
                return <GUIInstrumentGridID tabID={tabID} setSelectedToken={setSelectedToken} setSelectedChartSymbol={setSelectedChartSymbol}/>;
            case 3:
                return <GUIInstrumentGridID tabID={tabID} setSelectedToken={setSelectedToken} setSelectedChartSymbol={setSelectedChartSymbol}/>;
            case 4:
                return <GUIInstrumentGridID tabID={tabID} setSelectedToken={setSelectedToken} setSelectedChartSymbol={setSelectedChartSymbol}/>;
            case 5:
                return <GUIInstrumentGridID tabID={tabID} setSelectedToken={setSelectedToken} setSelectedChartSymbol={setSelectedChartSymbol}/>;
            case 6:
                return <GUIInstrumentGridID tabID={tabID} setSelectedToken={setSelectedToken} setSelectedChartSymbol={setSelectedChartSymbol}/>;
            case 7:
                return <GUIInstrumentGridID tabID={tabID} setSelectedToken={setSelectedToken} setSelectedChartSymbol={setSelectedChartSymbol}/>;
            case 8:
                return <GUIInstrumentGridID tabID={tabID} setSelectedToken={setSelectedToken} setSelectedChartSymbol={setSelectedChartSymbol}/>;
            default:
                return <DefaultGridComponent />;
        }
    };

    return (
        <div className="grid-wrapper">
            <div className="grid-container" ref={scrollContainerRef}>
                {tabList
                    .sort((a, b) => a - b)  // Sort the numbers in ascending order directly
                    /*.slice(startIndex, startIndex + gridCount)*/
                    .map((tab, index) => {
                        /*console.log("tabID: ",tab);  // Log the tabID to the console*/
                        return (
                            <div className={'instrument-grid-holder'} key={tab}>
                                {renderGridComponent(tab)}
                            </div>
                        );
                    })}
            </div>
        </div>
    );
};

export default MarketWatch;
